import React from 'react';

const loggedUser = { loggedUser: null, setLoggedUser: () => null };
export default React.createContext(loggedUser);
